import {computed, inject, Injectable} from '@angular/core'
import {ConfigService} from '@sparbanken-syd/sparbanken-syd-bankid'
import {ADMIN_HOOK_ROLE} from '../application/types'

@Injectable({
  providedIn: 'root'
})
export class RoleHelperService {
  private config = inject(ConfigService)
  public hookAdmin = computed(() => this.config.roles().includes(ADMIN_HOOK_ROLE))

}
